import { HttpError } from "../exceptions";

export const SESSION_EXPIRED_EVENT = "session:expired";

const isTokenExpired = (statusCode, body) =>
  statusCode === 403 && ["token expired", "Forbidden"].includes(body?.message);

const handleJsonResponse = async response => {
  const statusCode = response.status || 408;

  if (response.ok) {
    return response.json();
  }

  if (statusCode === 408) {
    throw new HttpError(statusCode, {}, "request timeout");
  }

  const body = await response.json();

  if (isTokenExpired(statusCode, body)) {
    window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT, { detail: { statusCode } }));
  }

  throw new HttpError(statusCode, body)
}

export const request = (url, method = "GET", payload, token) => {
  const body = payload ? JSON.stringify(payload) : null;
  const authorization = token ? { authorization: `Bearer ${token}` } : {};

  const headers = {
    "content-type": "application/json",
    ...authorization,
  };

  const params = {
    method,
    headers,
    body,
  };

  return fetch(url, params).then(handleJsonResponse);
}
